"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRpcError = exports.RpcError = void 0;
const runtime_rpc_1 = require("@protobuf-ts/runtime-rpc");
Object.defineProperty(exports, "RpcError", { enumerable: true, get: function () { return runtime_rpc_1.RpcError; } });
function isRpcError(error) {
    return error instanceof runtime_rpc_1.RpcError;
}
exports.isRpcError = isRpcError;
